import { useMemo } from "react";

export function usePayerHistoryResources(payerId: string) {
  return useMemo(
    () => [
      {
        resourceType: "Payer",
        resourceId: payerId
      }
    ],
    [payerId]
  );
}
